/**
 * 全局开关（RBAC 灰度用，对应 docs/RBAC实施方案.md §8.1）
 *
 * 出问题时的回退顺序：
 *   1. USE_PERM_BUTTON = false  → 按钮/操作全部放行（菜单仍按权限渲染）
 *   2. USE_ROUTE_GUARD = false  → 路由不做权限校验
 *   3. USE_PERM_MENU   = false  → 菜单回退到原有硬编码，权限体系对界面完全无影响
 */
export const USE_PERM_MENU = true;    // 菜单 / tab 是否按权限过滤
export const USE_PERM_BUTTON = true;  // 按钮 / 操作是否按权限显隐
export const USE_ROUTE_GUARD = true;  // 路由守卫是否做权限校验

/**
 * 安全阀：拿到的权限码集合为空 → 视为「该用户尚未接入 RBAC」，全部放行。
 *
 * ⚠️ 为什么必须开：目前只有平台侧 32 人被分配了角色，其余 80 人没有任何角色，
 * 权限码集合是空的。若不兜底，这些人一登录顶部菜单和系统管理页会全部消失（看起来像白屏）。
 * 等 P3 给存量客户批量分配完模板角色后，可以把它关掉。
 */
export const PERM_EMPTY_AS_FULL = true;
